var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1665 50.1667C7.1665 36.6532 7.1665 29.8963 11.3646 25.6981C15.5628 21.5 22.3196 21.5 35.8332 21.5H50.1665C63.68 21.5 70.4371 21.5 74.6349 25.6981C78.8332 29.8963 78.8332 36.6532 78.8332 50.1667C78.8332 63.6801 78.8332 70.4372 74.6349 74.6351C70.4371 78.8333 63.68 78.8333 50.1665 78.8333H35.8332C22.3196 78.8333 15.5628 78.8333 11.3646 74.6351C7.1665 70.4372 7.1665 63.6801 7.1665 50.1667Z",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3332 21.5C57.3332 14.7432 57.3332 11.3648 55.2341 9.26571C53.1349 7.16663 49.7566 7.16663 42.9998 7.16663C36.2431 7.16663 32.8646 7.16663 30.7656 9.26571C28.6665 11.3648 28.6665 14.7432 28.6665 21.5",
    stroke: "white",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0002 62.111C46.9583 62.111 50.1668 59.4371 50.1668 56.139C50.1668 52.8406 46.9583 50.1667 43.0002 50.1667C39.042 50.1667 35.8335 47.4928 35.8335 44.1944C35.8335 40.8963 39.042 38.2224 43.0002 38.2224M43.0002 62.111C39.042 62.111 35.8335 59.4371 35.8335 56.139M43.0002 62.111V64.5M43.0002 38.2224V35.8334M43.0002 38.2224C46.9583 38.2224 50.1668 40.8963 50.1668 44.1944",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.1bc7e9501432d2be73a89a670e18a504.svg";
export { ForwardRef as ReactComponent };